import React from 'react';

export const ResultScreen:React.VFC = ()=>{
  return (
    <>fwe
    </>
  );
};